import InvestorsOrderBy from 'src/app/shared/enums/InvestorsOrderBy.enum';

export class FundraisingUiState {
  public assetDetailsInvestorsSortBy: InvestorsOrderBy;
  constructor() {
    this.assetDetailsInvestorsSortBy = InvestorsOrderBy.TimeAddedNewToOld;
  }
  static fromJson(obj: any): FundraisingUiState {
    const model = new FundraisingUiState();
    model.assetDetailsInvestorsSortBy = obj.assetDetailsInvestorsSortBy ? obj.assetDetailsInvestorsSortBy : InvestorsOrderBy.TimeAddedNewToOld;
    return model;
  }
}
